import { render, staticRenderFns } from "./CreateMessage.vue?vue&type=template&id=054021d5&scoped=true&"
import script from "./CreateMessage.vue?vue&type=script&lang=js&"
export * from "./CreateMessage.vue?vue&type=script&lang=js&"
import style0 from "./CreateMessage.vue?vue&type=style&index=0&id=054021d5&prod&lang=scss&scoped=true&"
import style1 from "./CreateMessage.vue?vue&type=style&index=1&id=054021d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054021d5",
  null
  
)

export default component.exports